import { render, staticRenderFns } from "./Confimation.vue?vue&type=template&id=1ada1f02"
import script from "./Confimation.vue?vue&type=script&lang=js"
export * from "./Confimation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports